/**
 * Normalizes an MCO-style environment string into a Datadog `env` tag.
 *
 * Deployed MCO values carry a cluster prefix and an `-mco` suffix (`gaia-dev-mco`,
 * `prime-dev-mco`, `gaia-qa-alpha`, `gaia-tokyo`); keeping the segment after the
 * first hyphen collapses them to the tags Datadog targets on — `dev`, `qa`,
 * `staging`, `sandbox`, `ci`, `prod`, `tokyo` — so cluster and region variants
 * (`gaia-`/`prime-`, east/west) share one tag. Single-token values (`local`) pass
 * through; empty falls back to `local`.
 *
 * Nothing in this package calls it. It is here for hosts whose environment string
 * needs normalizing before being handed to `initFlags`, so each one does not
 * re-derive the same mapping.
 */
export const toDatadogEnv = (mcoEnv: string): string => {
  if (!mcoEnv) return 'local';
  const [first, second] = mcoEnv.split('-');
  return second || first;
};
